import type { RouteRecordRaw } from 'vue-router'
import { TICKETS_ROUTES } from '@/router/routes.enum'

export const reservationsRoutes: RouteRecordRaw[] = [
  {
    path: '/reservations',
    name: TICKETS_ROUTES.RESERVATIONS,
    component: () => import('@/tickets/modules/reservations/views/ReservationCheckout.view.vue')
  },
  {
    path: '/reservations/:id/confirmation',
    name: TICKETS_ROUTES.RESERVATIONS_CONFIRMATION,
    component: () => import('@/tickets/modules/reservations/views/ReservationConfirmation.view.vue')
  }
]
